import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import PriceCalc from './PriceCalc.js';
import './pricing.css';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Responsive from 'react-responsive';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Paper from '@material-ui/core/Paper';



const Mobile = props => <Responsive {...props} maxWidth={767} />;
const Default = props => <Responsive {...props} minWidth={768} />;

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  button: {
    margin: theme.spacing.unit,
    // boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    // fontWeight:'800',
    padding: '3px 6px',
    border: '1px solid',
    color: 'white',
    // lineHeight: 1.5,
    backgroundColor: 'rgb(114, 165,199)',
    borderColor: 'rgb(114, 165,199)',
    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
    '&:hover': {
      backgroundColor: '#203b60',
      borderColor: '#203b60',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#0062cc',
      borderColor: '#005cbf',
    },
  },
  textField: {
    // marginLeft: theme.spacing.unit,
    // marginRight: theme.spacing.unit,
    // width: 200,
    textAlign: "center",
    color: "#203b60",

    fontFamily: [
      'Open Sans',
      'sans-serif'

    ].join(','),
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
  root: {
    padding: 0,
    marginBottom: '1px'


  },
  Mcard: {
    display: 'flex',
    marginTop: '10px',
    marginBottom: '10px',
    width: '100%',
    padding: '0px',
    textAlign: 'center'
    // backgroundColor: '#84b4d2'
    // paddingLeft: '10%',
    // paddingTop:'10%'
    // height:'120px'
    // alignItems:'right'

  },
  Mdetails: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: "0px",
    // paddingTop:"10%",
    // paddingBottom:'10px',
  },
  paperImp: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginTop: '15px'
    // width:'100%'
  },
  Mcontent: {
    flex: '1 0 auto',
    // paddingTop: '10px',
    // marginTop: '15%',

    padding: "0px",
    textAlign: 'center'
  },
  Mcover: {
    width: "100px",
    height: "50px"
  },
  Mcontrols: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },
  MplayIcon: {
    height: 38,
    width: 38,
  },
  actions: {
    display: 'flex',
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },

  ContentCollapse: {
    backgroundColor: '#f2f2f2'
  }
});

class PackGrid extends Component {

  constructor(props) {
    super(props);
    this.state = {
      users: 0,
      total_month: 0,
      plan_names: [],
      checkedPlan: "Gold Plus",
      expanded: false
    }

    this.expandCard = this.expandCard.bind(this);

  }
  handleChecked = plan => event => {

    this.setState({
      checkedPlan: plan.name
    })

    this.props.handlePack(plan.id)

  };

  expandCard(id) {
    console.log("expanding Card")
    var expanded;
    if (parseInt(id) === this.state.expanded) {
      this.setState(
        {
          expanded: false
        }
      )
      return false
    }
    else {
      expanded = id
    }

    console.log("Expanded")
    console.log(expanded)

    this.setState({
      expanded: id
    })
  }


  render() {
    const { classes } = this.props;

    return (
      <div className="table-responsive">

        <Default>
          <Paper className={classes.paperImp} elevation={1}>
            <table className='table table-condensed price-grid-table'>

              <colgroup>
                <col id="no"></col>
                {this.props.plans.names.map((plan, index) => (
                  <col span="1" className={this.props.selected_pack === plan.id ? "column-selected" : ""}></col>
                ))}
              </colgroup>
              <tbody>

                <tr>
                  <td style={{ borderTop: "none" }}></td>
                  {this.props.plans.names.map((plan, index) => (

                    <td style={{ borderTop: "none" }} className="td-center">
                      <strong>{plan.name}</strong>
                      <Checkbox
                        checked={this.props.selected_pack === plan.id ? true : false}
                        value={plan.id}
                        color="primary"
                        onChange={this.handleChecked(plan)}
                        classes={{
                          root: classes.root,
                          // checked: classes.checked,
                        }}
                      />
                    </td>

                  ))}
                </tr>
                {this.props.plans.service_list.map((service, index) => (
                  <tr>
                    <td>{service.name} </td>
                    {this.props.plans.includes.map((include, index) => (
                      <td className="td-center td-support-content">{include[service.id] === false ? <i className="fa fa-1x fa-times"></i> : include[service.id] === true ? <i className="fa fa-1x fa-check text-beta"></i> : include[service.id]}</td>
                    ))}
                  </tr>
                ))}

                <tr>
                  <td><strong style={{ color: 'red', textDecoration: 'line-through', marginLeft: '3px' }}>Tarifa Regular</strong> </td>
                  {this.props.plans.prices.map((price, index) => (
                    <td style={{ color: 'red', textDecoration: 'line-through', marginLeft: '3px' }} className="td-center">${price['regular']} USD</td>
                  ))}

                </tr>
                <tr>
                  <td><strong>Tarifa Nuevo Cliente</strong> </td>
                  {this.props.plans.prices.map((price, index) => (
                    <td className="td-center">${price['new']} USD</td>
                  ))}

                </tr>



              </tbody>


            </table>
          </Paper>

        </Default>

        <Mobile>
          <div style={{ marginBottom: "10px" }} className="row">
            {this.props.plans.names.map((plan, index) => (

              <div className="col-md-12">
                <Card key={plan.id} className={classes.Mcard}>
                  <div className={classes.Mdetails}>

                    {/* <img className="app-card-img  img-fluid" src={'/img/' + item.img}></img> */}

                    <CardContent className={classes.Mcontent}>


                      <div style={{ marginTop: '20px' }} className="row">

                        <div className="col">
                          <Checkbox
                            // checked={this.props.selected_apps.map(function (app) { return app.id }).includes(item.id)}
                            // onChange={this.handleApp(item)}
                            checked={this.props.selected_pack === plan.id ? true : false}
                            onChange={this.handleChecked(plan)}
                            value="checkedB"
                            color="primary"
                          />
                        </div>


                        <div className="col">
                          <span className="support-title" >{plan.name} </span>
                          <div className="app-card-price">
                            {/* ${plan.prices[this.props.period]} USD */}
                            ${plan.price['new']} USD
                          </div>


                        </div>

                        <div className="col">


                          <ExpandMoreIcon style={{ marginLeft: '10px', marginTop: '10px' }} onClick={() => this.expandCard(plan.id)} />

                        </div>

                      </div>

                      <Collapse in={this.state.expanded === parseInt(plan.id)} timeout="auto">
                        <CardContent className={classes.ContentCollapse}>
                          {Object.keys(plan.includes).map((key, index) => (
                            <div>
                              {plan.includes[key] !== false &&

                                <div>
                                  {this.props.plans.service_list.map((service, index) => (
                                    <div>{parseInt(service.id) === parseInt(key) &&

                                      <div>
                                        <div style={{ textAlign: 'center', padding: '5px' }} className="app-card-price"> {plan.includes[key] === true ? '' : plan.includes[key]} {service.name}</div>

                                      </div>



                                    }</div>
                                  ))}

                                </div>
                              }
                            </div>
                          ))}
                        </CardContent>
                      </Collapse>


                    </CardContent>

                  </div>
                </Card>

              </div>

            ))}

          </div>

        </Mobile>





      </div>


    );
  }
}


PackGrid.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PackGrid);
// export default AppsGrid;